/**
 * [Gurumi 목록 스타일]
 * 역할: yesmoney StyledBulletList 포팅
 * 작성/수정일: 2026-07-29
 */
import BulletList from '@tiptap/extension-bullet-list';

export const StyledBulletList = BulletList.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      listStyle: {
        default: 'bullet',
        parseHTML: (el) => (el.getAttribute('data-list-style') === 'dash' ? 'dash' : 'bullet'),
        renderHTML: (attrs) => {
          if (attrs.listStyle === 'dash') {
            return { 'data-list-style': 'dash', class: 'editor-dash-list' };
          }
          return { 'data-list-style': 'bullet', class: 'editor-bullet-list' };
        },
      },
    };
  },
});
